
import { Vue, Component } from 'vue-property-decorator'
import SimpleTable from '@/components/busi/table/simple-table.vue'
import StaticItem from '@/components/busi/staticitem.vue'
import DictSelect from '@/components/busi/custom/dictselect.vue'
import util from '@/utils/busi/util'
import { getStudySelect, getBusinessAll } from '@/api/common/common'
import { getSchoolList } from '@/api/baseinformation'
import { insertUserAuth } from '@/api/systemset'
@Component({
  name: 'user-auth-edit',
  components: {
    SimpleTable,
    StaticItem,
    DictSelect
  }
})
export default class UserAuthEdit extends Vue {
  private formHeader: any = {
    userId: '',
    userName: ''
  }

  private form: any = {
    businessId: '',
    studyId: '',
    schoolName: ''
  }

  private businessData: any[] = []

  private studyData: any[] = []

  private selecteds: any[] = []

  private loading = !1

  private btnLoading = !1

  private tableData = {
    list: [],
    totalCount: 2
  }

  private columns = [
    {
      prop: 'schoolCode',
      label: '院校代码'
    },
    {
      prop: 'schoolName',
      label: '院校名称'
    },
    {
      prop: 'businessName',
      label: '业务类型'
    },
    {
      prop: 'studyName',
      label: '学习类型'
    }
  ]

  private pagination: any = {
    currentPage: 1,
    pageSize: 10
  }

  private roeClassName ({ row }: any) {
    const flag = this.selecteds.filter((v: any) => v.schoolId === row.id)
    return flag.length > 0 ? 'active' : ''
  }

  private userChange (val: any, label: any) {
    this.formHeader.userName = label
    // 清除所选院校
    // this.selecteds.splice(0, this.selecteds.length)
  }

  private async businessChange () {
    this.form.studyId = ''
    await getStudySelect({
      ...this.form
    }).then((res: any) => {
      this.studyData = res.object.list
    })
  }

  private async initQueryData () {
    await getBusinessAll({
      ...this.form
    }).then((res: any) => {
      if (res.code === 10000) {
        this.businessData = res.object
      }
    })
    await getStudySelect({
      ...this.form
    }).then((res: any) => {
      if (res.code === 10000) {
        this.studyData = res.object.list
      }
    })
  }

  private async onQuery (pagination: any = null) {
    this.loading = !0
    const form = util.trimForm({ ...this.form })
    form.schoolState = 1
    !pagination && (this.pagination.currentPage = 1)
    await getSchoolList({
      ...form,
      ...pagination || this.pagination
    }).then((res: any) => {
      this.loading = !1
      this.tableData.list = res.object.list
      this.tableData.totalCount = res.object.totalCount
    }).catch((err: any) => {
      console.log('err', err)
      this.loading = !1
    })
  }

  private onReset () {
    this.form = {
      businessId: '',
      studyId: '',
      schoolName: ''
    }
    this.onQuery()
  }

  private rowClick (row: any) {
    let flag = !1
    this.selecteds.map((val: any) => {
      if (row.id === val.schoolId) {
        flag = !0
      }
    })
    flag || this.selecteds.push({
      schoolId: row.id,
      schoolName: row.schoolName
    } as never)
  }

  private async close (id: any) {
    const temp = this.selecteds
    this.selecteds = temp.filter((val: any) => val.schoolId !== id)
  }

  private async onSave () {
    const datas: any = []
    if (!this.formHeader.userId) {
      this.$message.error('请选择用户姓名')
      return
    }
    if (this.selecteds.length === 0) {
      this.$message.error('请选择至少一个院校')
      return
    }
    this.btnLoading = !0
    this.selecteds.map((val: any) => {
      datas.push({
        userId: this.formHeader.userId,
        userName: this.formHeader.userName,
        schoolId: val.schoolId,
        schoolName: val.schoolName
      } as never)
    })
    await insertUserAuth(datas as any).then((res: any) => {
      this.btnLoading = !1
      if (res.code === 10000) {
        this.$message(res.message)
        this.onBack()
      } else {
        this.$message.error(res.message)
      }
    }).catch((err: any) => {
      console.log('err', err)
      this.btnLoading = !1
    })
  }

  private async onBack () {
    this.$router.push({
      name: 'userAuthList'
    })
  }

  mounted () {
    this.initQueryData()
    this.onQuery()
  }
}
